"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _WithPaymentLink = _interopRequireDefault(require("./WithPaymentLink"));

var _WithoutPaymentLink = _interopRequireDefault(require("./WithoutPaymentLink"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function NewStatus(_ref) {
  var inProcess = _ref.inProcess,
      data = _ref.data;
  var paymentLink = data === null || data === void 0 ? void 0 : data['paymentLink'];

  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper'],
      "data-locator": 'identification.new'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, paymentLink ? /*#__PURE__*/_react["default"].createElement(_WithPaymentLink["default"], {
      link: paymentLink
    }) : /*#__PURE__*/_react["default"].createElement(_WithoutPaymentLink["default"], {
      inProcess: inProcess
    }, "\u041D\u0430\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

NewStatus.defaultProps = {
  inProcess: false,
  data: null
};
var _default = NewStatus;
exports["default"] = _default;